import { BilateralTradeProductType } from '@ebalance/proto/bfftypes/v1/bilateral_trade_product_type_pb'
import type { Supply48DataSource } from '@ebalance/proto/bffuser/v1/supply_48_data_model_pb'
import { Supply48SourceType } from '@ebalance/proto/bffuser/v1/supply_48_data_model_pb'

/**
 * 編集可能な (= 保存・revert 対象になり得る) source かどうかの allow-list 判定
 * (AC-S4D-032)。現状 CONTRACT のみが編集可能で、それ以外 (市場・将来追加され
 * うる未対応 source type を含む) はすべて fail-closed で編集不可とする。
 *
 * `sourceType === MARKET` の deny-list ではなく allow-list にしているのは、
 * 発電 (GENERATION、予約のみで現状行なし) のような「市場でも契約でもない」
 * 将来の source type が追加された時に、deny-list だと明示的に除外し忘れた
 * 新種別が黙って編集可能になる (= 保存対象外にすべき行が保存 payload に紛れる)
 * 事故を構造的に防ぐため。
 *
 * grid の編集可否判定 (`cellAt` / `GridCell.isEditable`) ・edit-session の
 * revert (`doRevertLegToAuto` / `doRevertAllToAuto`) ・保存 payload 構築
 * (`saveRows.ts` の `editableSourceIds`) がこの 1 判定を共有する。
 */
export function isEditableSource(source: Supply48DataSource): boolean {
  return source.sourceType === Supply48SourceType.CONTRACT
}

/**
 * 市場 (スポット・時間前) source かどうか (AC-S4D-032)。表示用途 (市場列ヘッダ
 * のラベル切替・GC 案内 / Excel 操作案内の抑止等) にのみ使う — 編集可否の gate
 * には `isEditableSource` の allow-list を使う (deny-list の書き写しをしない)。
 */
export function isMarketSource(source: Supply48DataSource): boolean {
  return source.sourceType === Supply48SourceType.MARKET
}

/**
 * 商品形態が非定型の取引の source か (AC-S4D-060)。非定型の取引は契約から全コマ 0 の行が
 * 作られ、実数量を手動変更の値として入れる (supply-48-generation.md §5)。
 * 差金決済タブの除外は区分の判定なので呼び出し側で行う (`nonStandardLegIds`)。
 */
export function isNonStandardSource(source: Supply48DataSource): boolean {
  return (
    source.detail.case === 'contract' &&
    source.detail.value.productType === BilateralTradeProductType.NON_STANDARD
  )
}
